<template>
  <div class="original-bill">
    <div class="header">
      <el-input class="query" v-model.trim="billDate" placeholder="请输入对账账期" @keyup.native.enter="getBillList(1)" clearable @clear="getBillList(1)"></el-input>
      <el-button type="primary" @click="getBillList(1)">查询</el-button>
    </div>
    <Table :data="billList" :columns="columns" :pages="pages"></Table>
    <el-dialog title="处理结果" :visible="visible" width="600px" :before-close="close">
      <el-form ref="form" :rules="rules" label-position="top" :model="form">
        <el-form-item label prop="remark">
          <el-input type="textarea" rows="3" maxlength="300" placeholder="请输入处理结果描述" v-model.trim="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BillService from "@/apis/BillService";
import Table from "@/components/new-table.vue";
import { BillOrderType, ErrorHandlerStatus, ErrorType } from "@/service/enum";
export default {
  components: { Table },
  data() {
    return {
      billDate: "",
      billList: [],
      columns: [
        { label: "对账账期", prop: "billDate", "min-width": "80px" },
        { label: "订单号", prop: "orderNo", "min-width": "150px" },
        { label: "订单状态", prop: "orderStatusLabel", "min-width": "80px" },
        { label: "订单金额", prop: "orderMoney", "min-width": "80px" },
        { label: "异常类型", prop: "errorTypeLabel", "min-width": "80px" },
        { label: "处理状态", prop: "disposeStatusLabel", "min-width": "80px" },
        { label: "交易单号", prop: "dhOrderNo", "min-width": "240px" },
        { label: "金额", prop: "sonAccountMoney", "min-width": "80px" },
        { label: "服务费", prop: "serviceFee", "min-width": "80px" },
        { label: "创建时间", prop: "creationTime", "min-width": "150px" },
        { label: "处理说明", prop: "remark", "min-width": "150px" },
        { label: "处理时间", prop: "disposeDateTime", "min-width": "150px" },
      ],
      pages: {
        props: {
          total: 0,
          "page-size": 20,
          "current-page": 1,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizesChange
        },
      },
      visible: false,
      form: {
        remark: ""
      },
      rules: {
        remark: [{ required: true, message: '请输入处理结果描述' }],
      },
      curRow: {}
    }
  },
  mounted() {
    this.getBillList();
  },
  methods: {
    getBillList(pageIndex) {
      const page = pageIndex || this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      BillService.getDifferenceList(page, pageSize, this.$route.query.id || "", this.billDate).then(res => {
        this.billList = res.data.map(i => {
          i.orderStatusLabel = BillOrderType[i.orderStatus]
          i.errorTypeLabel = ErrorType[i.errorType]
          i.disposeStatusLabel = ErrorHandlerStatus[i.disposeStatus]
          i.serviceFee = (i.mainAccountMoney + i.serviceCharge).toFixed(2) //服务费=平台的结算金额+手续费
          return i
        });
        this.pages.props.total = res.dataCount;
      });
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getBillList(1);
    },
    currentChange(page) {
      this.pages.props["current-page"] = page;
      this.getBillList();
    },
    showHandDiff(row) {
      this.curRow = row;
      this.form.remark = row.remark;
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.visible = false;
    },
    async confirm() {
      await this.$refs.form.validate();
      BillService.handlerDifference(this.curRow.id, this.form.remark).then(res => {
        if (res) this.$message.success("保存成功");
        this.visible = false;
        this.curRow.remark = this.form.remark;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.original-bill {
  display: flex;
  flex-direction: column;
}
.header {
  margin-bottom: 20px;
}
.query {
  width: 200px;
  margin-right: 20px;
  vertical-align: middle;
}
.state {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .state-dot {
    width: 5px;
    margin-right: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
</style>